import { render, staticRenderFns } from "./ThePopup.vue?vue&type=template&id=2a8fd642&scoped=true&"
import script from "./ThePopup.vue?vue&type=script&lang=js&"
export * from "./ThePopup.vue?vue&type=script&lang=js&"
import style0 from "./ThePopup.vue?vue&type=style&index=0&id=2a8fd642&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8fd642",
  null
  
)

export default component.exports